// extracted by mini-css-extract-plugin
module.exports = {"rating":"rating_rating__COCA9","count":"rating_count__zJG6P"};